<div class="modal-header">
	<ng-container *ngIf="!params?.title_html; else custom_title_html">
		<h2 *ngIf="!params?.reduce_title_size; else reduced_title" class="no-margin-bottom"> {{ params.title | tt }}</h2>
		<ng-template #reduced_title>
			<h5 class="no-margin-bottom text-color-primary-blue"> {{ params.title | tt }}</h5>
		</ng-template>
	</ng-container>

	<ng-template #custom_title_html>
		<div [innerHTML]="params.title_html | safeHtml"></div>
	</ng-template>

	<button type="button" class="btn-modal-close close" aria-label="Close" (click)="modal.dismiss()">
		&times;
	</button>
</div>

<div class="modal-body">
	<ng-container *ngIf="params.inner_message; else string_message">
		<div [innerHTML]="params.inner_message | safeHtml"></div>
	</ng-container>
	<ng-template #string_message>
		{{ params.message | tt }}
	</ng-template>

	<ng-container *ngIf="params.input">
		<div class="row align-items-center my-1">
			<label class="col-auto col-form-label" for="confirm_input">
				{{ params.input.label | tt }}
			</label>

			<div class="col-8">
				<input class="form-control"
				       [type]="params.input.type || 'text'"
				       [placeholder]="params.input.placeholder ? (params.input.placeholder | tt) : ''"
				       id="confirm_input"
				       name="confirm_input"
				       [(ngModel)]="params.input.value">
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="params.custom_checkbox_label">
		<label class="mt-2 vertical-align user-select-none" role="button" for="custom_checkbox">
			<input
				class="me-1"
				type="checkbox"
				role="button"
				id="custom_checkbox"
				[(ngModel)]="params.custom_checkbox_value">
			{{ params.custom_checkbox_label }}
		</label>
	</ng-container>

	<ng-container *ngIf="params.dont_show_again_checkbox">
		<label class="mt-4 vertical-align user-select-none" role="button" for="dontShowAgain">
			<input
				class="me-1"
				type="checkbox"
				role="button"
				id="dontShowAgain"
				[(ngModel)]="params.dont_show_again">
			{{ 'Do not show this again' | tt }}
		</label>
	</ng-container>

	<ng-container *ngIf="params.agreement_checkbox">
		<div class="checkbox ms-4 mt-3">
			<input type="checkbox"
			       class="form-control"
			       id="agreement_checkbox"
			       (change)="agreement = !agreement">
			<label for="agreement_checkbox" class="user-select-none" tt><!--#305E9A blue-->
				I understand
			</label>
		</div>
	</ng-container>
</div>

<div class="modal-footer" [ngClass]="{'pt-0':params.agreement_checkbox}">
	<button type="button"
	        *ngIf="params.cancel_button"
	        class="btn btn-secondary"
	        [ngClass]="{'btn-sm': params?.reduce_title_size || params?.reduce_button_size}"
	        (click)="modal.dismiss()">
		{{ params.cancel_button | tt }}
	</button>
	<button type="button"
	        *ngIf="params.ok_button"
	        class="btn btn-primary-custom"
	        [ngClass]="{'btn-sm': params?.reduce_title_size || params?.reduce_button_size}"
	        [disabled]="in_process || !agreement || !isInputValid"
	        (click)="close()">
		{{ params.ok_button | tt }}
	</button>
</div>
